import { Component } from 'react'
import _ from 'lodash'
import clx from 'classnames'
import { FetchDataUtil } from '@vzmi/component_ec_nodejs_util'
import styles from './PageViewsAnalysis.css'
import safeAwait from '../../../../../lib/safeAwait'
import Tabs from '../../../Common/NewDashboard/Tabs/Tabs'
import PageViewsDaily from './PageViewsDaily/PageViewsDaily'
import PageViewsSource from './PageViewsSource/PageViewsSource'
import { GA_CLICK_ACTION, getI13nModel } from './PageViewsAnalysis.ga'
import { getParamsListByMonth } from '../Shared'

export const TAB = {
  DAILY: 'daily',
  SOURCE: 'source'
}

const TAB_MAP = {
  [TAB.DAILY]: '日瀏覽量',
  [TAB.SOURCE]: '瀏覽量來源'
}

const PAGE_VIEWS_API_LIMIT = 120

class PageViewsAnalysis extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedTab: TAB.DAILY
    }
  }

  onTabChange = tabKey => this.setState({ selectedTab: tabKey })

  onTabClick = (tabKey, e) => {
    this.sendPageviewByAction({
      type: GA_CLICK_ACTION.TAB,
      payload: tabKey
    })
  }

  fetchMonthlyListingPageViews = async (params) => {
    const [error, listingPageViews] = await safeAwait(
      FetchDataUtil.fetchAllPages(params => {
        return this.props.fetchListingPageViews(params)
          .then(res => {
            if (res.error) {
              throw res
            }
            return res
          })
      }, {
        payload: params,
        selector: res => _.get(res, 'pageViews', [])
      })
    )
    if (error) {
      return Promise.reject(error)
    }

    return listingPageViews
  }

  fetchAllListingPageViews = async (params) => {
    const paramsWithLimit = {
      limit: PAGE_VIEWS_API_LIMIT,
      ...params
    }
    // API 限制日期區間最長一個月，因此跨月需要分開打
    const paramsList = getParamsListByMonth(paramsWithLimit)
    const [error, allListingPageViewsResp] = await safeAwait(
      Promise.all(
        // 查詢單一個月全部 pageView
        paramsList.map(perMonthParams => this.fetchMonthlyListingPageViews({
          ...paramsWithLimit,
          ...perMonthParams
        }))
      )
    )
    if (error) {
      return Promise.reject(error)
    }

    // 將每個月的 pageView 加總
    const allListingPageViews = _.reduce(allListingPageViewsResp, (sumPageViews, resp) => {
      sumPageViews = sumPageViews.concat(resp.data)
      return sumPageViews
    }, [])
    const pagination = _.flow(
      _.head,
      firstResp => _.get(firstResp, 'pagination')
    )(allListingPageViewsResp)
    return { data: allListingPageViews, pagination }
  }

  sendPageviewByAction = (action) => {
    const i13nModel = getI13nModel(action)
    this.props.sendDashboardPageview(i13nModel)
  }

  render () {
    const { className, fetchSaleStatsByDate, flags } = this.props
    const { selectedTab } = this.state
    const clz = clx(styles.PageViewsAnalysis, {
      [className]: !!className
    })
    return (
      <div
        className={clz}
        data-role='page-views-analysis'
      >
        <Tabs
          key='tabs'
          activeKey={selectedTab}
          onChange={this.onTabChange}
          onTabClick={this.onTabClick}
          items={[
            {
              label: TAB_MAP[TAB.DAILY],
              key: TAB.DAILY,
              children: (
                <PageViewsDaily
                  fetchAllListingPageViews={this.fetchAllListingPageViews}
                  fetchSaleStatsByDate={fetchSaleStatsByDate}
                  sendPageviewByAction={this.sendPageviewByAction}
                  flags={flags}
                />
              )
            },
            {
              label: TAB_MAP[TAB.SOURCE],
              key: TAB.SOURCE,
              children: (
                <PageViewsSource
                  fetchAllListingPageViews={this.fetchAllListingPageViews}
                  sendPageviewByAction={this.sendPageviewByAction}
                  flags={flags}
                />
              )
            }
          ]}
        />
      </div>
    )
  }
}

export default PageViewsAnalysis
